import { Button, Modal, Tabs, Form, Col, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import CadastrarParceiro from '../../../../../../../../components/CadastrarParceiro';
import { ApplicationState } from '../../../../../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';
import mask from '../../../../../../../../utils/mask';
import { loadRequest } from '../../../../../../../../store/ducks/tomadoresTransportadora/actions';
import TitlePage from 'components/TitlePage';

export interface Props {
  setSelectedTomadorOrdemCarga?: any | undefined;
  disabled?: boolean;
  nometomadorXml?: string;
  setNomeTomadorXML?: React.Dispatch<React.SetStateAction<string>>;
}

const SelectTomador: React.FC<Props> = ({
  setSelectedTomadorOrdemCarga,
  nometomadorXml,
  setNomeTomadorXML,
  disabled
}) => {
  const { Option } = Select;
  const dispatch = useDispatch<React.Dispatch<Action>>();
  const { TabPane } = Tabs;
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nomeTomador, setNomeTomador] = useState<string>('Selecione o tomador');
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const tomadoresTransportadora = useSelector(
    (state: ApplicationState) => state.TomadoresTransportadora.data
  );

  useEffect(() => {
    setNomeTomador(nometomadorXml ? nometomadorXml : 'Selecione o tomador');
  }, [nometomadorXml]);

  useEffect(() => {
    dispatch(loadRequest(inscricaoAtiva));
  }, [dispatch, inscricaoAtiva]);

  const handleSelect = (value: any, e: any) => {
    setNomeTomadorXML?.(value);
    setSelectedTomadorOrdemCarga(+e?.key);
  };

  const onFinish = (value: any): void => {
    setIsModalVisible(false);
    setNomeTomador(value.tomador);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button type="dashed" style={{ width: '100%' }} onClick={() => setIsModalVisible(true)} disabled={disabled}>
        {nomeTomador ? mask('camelCase', nomeTomador) : 'Selecione o tomador'}
      </Button>
      <Modal
        title={<TitlePage>Tomador</TitlePage>}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={850}
        footer={[]}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="Parceiros cadastrados" key="1">
            <Form form={form} onFinish={onFinish}>
              <Form.Item
                name="tomador"
                rules={[
                  {
                    required: true,
                    message: <span style={{ color: 'red' }}>Por favor, selecione o tomador</span>,
                  },
                ]}
              >
                <Select
                  onChange={handleSelect}
                  showSearch
                  filterOption={(inputValue, element) =>
                    element?.props.children
                      .toString()
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                >
                  {tomadoresTransportadora?.map((item: any) => (
                    <Option key={item.codParc} value={item.nome}>
                      {item.nome}
                      <br />
                      {mask('cpfCnpj', item.cnpjCpf)}
                      <br />
                      {item.inscricaoEstadual}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Col style={{ textAlign: 'right' }}>
                <Button type="primary" htmlType="submit">
                  OK
                </Button>
              </Col>
            </Form>
          </TabPane>
          (
          <TabPane tab="Novo parceiro" key="2">
            <CadastrarParceiro
              setIsModalVisible={setIsModalVisible}
              setNomeTomador={setNomeTomador}
              setSelectedTomadorOrdemCarga={setSelectedTomadorOrdemCarga}
            />
          </TabPane>
          )
        </Tabs>
      </Modal>
    </>
  );
};

export default SelectTomador;
